// src/context/prospect/prospectReducer.js
export default function prospectReducer(state, action) {
  switch (action.type) {
    case "CREATING_PROSPECT":
      return { ...state, creating: true, error: null };
    case "PROSPECT_CREATED":
      return {
        ...state,
        creating: false,
        error: null,
        lastProspect: action.payload,
      };
    case "PROSPECT_ERROR":
      return { ...state, creating: false, error: action.payload };

    case "CRON_RUNNING":
      return { ...state, cronRunning: true, error: null };
    case "CRON_DONE":
      return {
        ...state,
        cronRunning: false,
        error: null,
        lastCronResult: action.payload,
      };
    case "CRON_ERROR":
      return { ...state, cronRunning: false, error: action.payload };

    default:
      return state;
  }
}
